import { IsNotEmpty, IsNumber, IsPositive } from 'class-validator';

export class UserTransferDto {
  @IsNotEmpty()
  email: string = '';

  @IsNotEmpty()
  @IsPositive()
  @IsNumber()
  amount: number = 0;

  error?: string;

  constructor(email: string, amount: number, error: string) {
    this.email = email;
    this.amount = amount;
    this.error = error;
  }
}
